<template>
  <div id="content-container">
    <div id="page-head">
      <div id="page-title">
        <h1 class="page-header text-overflow">{{ $route.meta.name }}</h1>
      </div>
      <ol class="breadcrumb">
        <li>
          <i class="ion-home"></i>
        </li>
        <li>{{ $route.meta.name }}管理</li>
        <li class="active">{{ $route.meta.name }}</li>
      </ol>
    </div>
    <div id="page-content">
      <div class="row">
        <div class="col-sm-12">
          <div class="panel">
            <div class="panel-heading">
              <h3 class="panel-title">{{ $route.meta.name }}</h3>
            </div>

            <div class="panel-body">
              {{ item.name }}
              <!-- <item-table :items="items.list"></item-table> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pdcDetail } from '@/service/getData'

export default {
  data() {
    return {
      item: {},
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await pdcDetail(this.$route.params.id)
      if (res.status != 0) return
      this.item = res.data
    },
  },
}
</script>